export default __webpack_public_path__ + "static/media/handPhone.2b26bb90.png";